export async function sendAgencyTracking({ isTracking, utms = {} }) {
    if (!isTracking) {
        return
    }

    if (window.location.href.includes('localhost') || window.location.href.includes('digiworks')) {
        return
    }

    if (window.OptinTracking && utms.var_oc) {
        const affiliateCampaignId = 'auto'
        const tracking = new window.OptinTracking({ affiliateCampaignId })
        await tracking.generate()
        tracking.clean()
        console.log('OptinTracking generated: var_oc')
    }

    if (utms.aff_sub2) {
        const img = document.createElement('img')
        img.src = `https://tracking.tgmfr.com/aff_lsr?offer_id=3109&transaction_id=${encodeURIComponent(utms.aff_sub2)}`
        img.width = 1
        img.height = 1
        img.style.display = 'none'
        document.body.appendChild(img)
        console.log('TGMFR tracking generated: aff_sub2')
    }

    if (utms.click_id) {
        const img = document.createElement('img')
        img.src = `https://link.advenly.com/track/conv?click_id=${encodeURIComponent(utms.click_id)}&token=800bc991`
        img.width = 1
        img.height = 1
        img.style.display = 'none'
        document.body.appendChild(img)
        console.log('Advenly tracking generated: click_id')
    }

    if (utms.cid && utms.utm_campaign) {
        const img = document.createElement('img')
        img.src = `https://tracking.mkdgroupe.dev/pb/markaltis-comptoir-juin26?cid=${encodeURIComponent(utms.cid)}&utm_source=${encodeURIComponent(utms.utm_source || '')}&utm_medium=${encodeURIComponent(utms.utm_medium || '')}&utm_term=${encodeURIComponent(utms.utm_term || '')}&utm_content=${encodeURIComponent(utms.utm_content || '')}&utm_campaign=${encodeURIComponent(utms.utm_campaign)}`
        img.width = 1
        img.height = 1
        img.style.display = 'none'
        document.body.appendChild(img)
        console.log('MKD tracking generated: cid and utm_campaign')
    }
}